/**
 * A Canvas2D example of generative/algorithmic artwork, sized for print.
 * @author Matt DesLauriers (@mattdesl)
 * @author Tomasz Kaszewski (@tomekq)
 */
document.querySelector('body').style.backgroundColor = '#444';

const canvasSketch = require('canvas-sketch');
const Random = require('canvas-sketch-util/random');
const { lerp } = require('canvas-sketch-util/math');
const { math } = require('canvas-sketch-util');
const Tweakpane = require('tweakpane');

let manager;
let rendered = false;
const settings = {
	//suffix: Random.getSeed(),
	dimensions: [ 1080, 1080 ],
	id: 'canvas',
	animate: 0
};
const params = {
	setSeed: false,
	count: 6700,
	amplitude: 250,
	noiseAngleFactor: 2,
	reRender: false,
	radiusMin: 2,
	radiusMax: 16,
	alphaMin: 0.3,
	alphaMax: 0.1,
	color1: '#e88a31',
	color2: '#329a05',
	gaussStd: 0.01,
	gaussMean: 0
};

Random.setSeed(Random.getRandomSeed());
let slices = (width, height) => {
	if (params.setSeed) {
		Random.setSeed(Random.getRandomSeed());
	}
	let aColorList = [ params.color1, params.color2 ];
	const sliceCount = params.count;
	let slices = Array.from(new Array(sliceCount)).map((_, i, list) => {
		const t = list.length <= 1 ? 0 : i / (list.length - 1);
		const noiseAngle = t * Math.PI * params.noiseAngleFactor;
		const nx = Math.cos(noiseAngle);
		const ny = Math.sin(noiseAngle);
		const nf = 0.05 + Random.range(0, 0.5);
		const noise = Random.noise2D(nx * nf, ny * nf);
		const noise01 = noise * 0.5 + 0.5;

		const tOffset = Random.gaussian(params.gaussMean, params.gaussStd); //mean, std deviation

		const cx = width / 2;
		const x = cx + noise * params.amplitude;
		const color = Random.pick(aColorList);
		const radius = Random.range(params.radiusMin, params.radiusMax);
		const alpha = math.mapRange(radius, params.radiusMin, params.radiusMax, params.alphaMin, params.alphaMax);

		return {
			alpha: alpha * (1 - noise01), //Random.range(0.4, 1) * (1 - noise01),
			color: color,
			radius: radius,
			cx: cx,
			noise: noise,
			amplitude: params.amplitude,
			x,
			y: lerp(0, height - 0, t + tOffset)
		};
	});
	return slices;
};

const sketch = ({ context, width, height, frame }) => {
	let slicesx = slices(width, height);

	return () => {
		if (params.reRender) {
			slicesx = slices(width, height);
			params.reRender = false;
		}

		context.globalCompositeOperation = 'source-over';
		context.fillStyle = 'black';
		context.fillRect(0, 0, width, height);
		context.globalCompositeOperation = 'lighter';

		if (!rendered) {
			rendered = true;
		} else {
			slicesx = Array.from(slicesx).map((_, i, list) => {
				const x = _.cx + _.noise * params.amplitude;
				return {
					alpha: _.alpha,
					color: _.color,
					radius: _.radius,
					cx: _.cx,
					noise: _.noise,
					amplitude: params.amplitude,
					x: x,
					y: _.y
				};
			});
		}

		slicesx.forEach((slice) => {
			context.save();
			context.beginPath();
			context.translate(slice.x, slice.y);
			context.arc(0, 0, slice.radius, 0, Math.PI * 2);
			context.fillStyle = slice.color;
			context.globalAlpha = slice.alpha;
			context.fill();
			context.stroke();
			context.restore();
		});
	};
};
const createPane = () => {
	const pane = new Tweakpane.Pane();
	let folder;
	folder = pane.addFolder({ title: 'Params with no re-render' });
	folder.addInput(params, 'amplitude', { min: 10, max: 400, step: 1 }).on('change', (ev) => {
		manager.render();
	});

	rerender = pane.addFolder({ title: 'Params with re-render' });
	rerender.addInput(params, 'setSeed').on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'gaussStd', { min: 0.01, max: 0.1, step: 0.01 }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'radiusMin', { min: 0.1, max: 5, step: 0.1, label: 'radius1' }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'radiusMax', { min: 1, max: 100, step: 1, label: 'radius2' }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'alphaMin', { min: 0, max: 1, step: 0.1, label: 'alpha1' }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'alphaMax', { min: 0, max: 1, step: 0.1, label: 'alpha2' }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'count', { min: 1, max: 10000, step: 10 }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender.addInput(params, 'noiseAngleFactor', { min: 1, max: 20, step: 1 }).on('change', (ev) => {
		params.reRender = true;
		manager.render();
	});
	rerender
		.addButton({
			title: 'Re-render'
			//label: 'counter',   // optional
		})
		.on('click', () => {
			params.reRender = true;
			manager.render();
		});
	rerender
		.addInput(params, 'color1', {
			picker: 'inline',
			expanded: true
		})
		.on('change', (e) => {
			params.reRender = true;
			manager.render();
		});
	rerender
		.addInput(params, 'color2', {
			picker: 'inline',
			expanded: true
		})
		.on('change', (e) => {
			params.reRender = true;
			manager.render();
		});
};

createPane();
const start = async () => {
	manager = await canvasSketch(sketch, settings);
};
start();
